import {
  type DisplayStyleConfig,
  SuggestedModuleDisplayStyle,
  type SuggestedModuleFormState,
  SuggestedModuleType,
} from '@/types/suggestedModules';

export const MODULE_TYPES = [
  { label: 'RSS Feed', value: SuggestedModuleType.RSS_FEED },
  { label: 'Video', value: SuggestedModuleType.VIDEO },
  { label: 'Web Link', value: SuggestedModuleType.WEB_LINK },
];

export const DISPLAY_STYLES: DisplayStyleConfig[] = [
  {
    value: SuggestedModuleDisplayStyle.CARD,
    label: 'Card',
    description: 'Best for daily updated content with nice image',
    icon: 'IconCarouselHorizontal',
    badge: 'RECOMMENDED',
  },
  {
    value: SuggestedModuleDisplayStyle.LIST,
    label: 'List',
    description: 'Designed for text-based content',
    icon: 'IconList',
    badge: 'RECOMMENDED',
  },
  {
    value: SuggestedModuleDisplayStyle.BANNER,
    label: 'Banner',
    description: 'Display only the latest content',
    icon: 'IconRectangle',
  },
];

export const INITIAL_FORM_STATE: SuggestedModuleFormState = {
  name: '',
  description: '',
  moduleType: SuggestedModuleType.RSS_FEED,
  url: '',
  displayStyle: SuggestedModuleDisplayStyle.CARD,
  isVideoMultiple: false,
  thumbnailPreview: null,
  thumbnailPath: null,
  startDate: null,
  endDate: null,
};

export const ACTION_ICON_SIZE = 20;
